export default __webpack_public_path__ + "static/media/ic_tether_24.41e3f2b5.svg";